import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Device } from 'src/app/classes/device';
import { DashboardService } from '../dashboard.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MustMatch } from 'src/app/data-service/must-match.validator';
@Component({
  selector: 'app-add-error-log',
  templateUrl: './add-error-log.component.html',
  styleUrls: ['./add-error-log.component.scss']
})
export class AddErrorLogComponent implements OnInit {
  private ResponseVerifiedAddDevice$: Subject<any> = new Subject();
  private ResponseVerifiedUpdateDevice$: Subject<any> = new Subject();
  private ResponseVerifiedGetDeviceInfo$: Subject<any> = new Subject();
  private ResponseVerifiedGetAllEpcUser$: Subject<any> = new Subject();

  public uploadFlagSpinner;
  deviceInfo = new Device();
  adddeviceForm: FormGroup;
  message: string;
  dev_name: any;
  isEditing: any;
  deviceId: any;
  editDeviceObject: any = {};
  dataObject: any = [];
  editSerial_No: string;
  editDev_Name: any;
  editEpcId: any;
  editCompany_Name: any;
  editMake_Id: any;
  editMax_Param_Count: any;
  editInverter_Capacity: any;
  public adminEpcUserList: any;
  role: any;
  roleName: string;
  search: any = '';
  page = 1;
  limit: any = 0;
  offset: any = 0;
  srcString: any;
  editRegistered_By: any;
  getEpcObj: any;
  flag: any;
  error_no: any;
  editUserObject: any = {};
  time: any = [{ "id": "01" }, { "id": "02" }, { "id": "03" }, { "id": "04" }, { "id": "05" }, { "id": "06" }, { "id": "07" }, { "id": "08" }, { "id": "09" }, { "id": "10" }, { "id": "11" }, { "id": "12" }, { "id": "13" }, { "id": "14" }
    , { "id": "15" }, { "id": "16" }, { "id": "17" }, { "id": "18" }, { "id": "19" }, { "id": "20" }
    , { "id": "21" }, { "id": "22" }, { "id": "23" }, { "id": "24" }, { "id": "25" }, { "id": "26" }
    , { "id": "27" }, { "id": "28" }, { "id": "29" }, { "id": "30" }, { "id": "31" }, { "id": "32" }
    , { "id": "33" }, { "id": "34" }, { "id": "35" }, { "id": "36" }, { "id": "37" }, { "id": "38" }, { "id": "39" }, { "id": "40" }
  ];

  constructor(private fb: FormBuilder, private router: Router, private route: ActivatedRoute, private dashbord: DashboardService,
    private toastr: ToastrService) {

    this.route.queryParams.subscribe(params => {
      if (params.device_id) {
        this.isEditing = true;
        this.deviceId = params.device_id;
      }
    });
    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    } else if (this.role == '5') {
      this.roleName = 'slave_admin';
    }
    this.route.queryParams.subscribe(params => {
      if (params.error_no) {
        this.isEditing = true;
        this.error_no = params.error_no;
      }
    });
  }

  ngOnInit() {
    this.adddeviceForm = this.fb.group({
      param_bit: [null, [Validators.pattern("^[0-9]*$")]],//[a-zA-Z0-9][a-zA-Z0-9 ]+
      make_id: ['0'],
      param_id: ['0'],
      alarm_name: ['', [Validators.required, Validators.pattern("^[a-zA-Z !@#$%^&*()-]+$")]],
      alarm_msg: ['', [Validators.required, Validators.pattern("^[a-zA-Z ,]+$"), Validators.maxLength(150)]],
      param_value: ['', [ Validators.pattern("^[0-9]+(.[0-9]{0,5})?$")]],
    }
    );

    if (this.isEditing == true) {
      this.getInfoByUserId();
    }

    if (this.roleName == 'admin' || this.roleName == 'slave_admin') {
      this.getAllEpcUser();
    }

  }

  // Epc Info By Id
  getInfoByUserId() {

    this.editUserObject = {
      error_no: this.error_no
    };
    this.dashbord.getInfoByUserIdError(this.editUserObject)
      .pipe()
      .subscribe(
        async data => {
          if (data.status) {
            this.editUserObject = {};
            this.dataObject = data.resultObject;
            this.adddeviceForm.get('make_id').setValue(data.resultObject[0].make_id);
            this.adddeviceForm.get('param_id').setValue(data.resultObject[0].param_no);
            this.adddeviceForm.get('param_bit').setValue(data.resultObject[0].param_bit);
            this.adddeviceForm.get('alarm_name').setValue(data.resultObject[0].alarm_name);
            this.adddeviceForm.get('alarm_msg').setValue(data.resultObject[0].alarm_msg);
            this.adddeviceForm.get('param_value').setValue(data.resultObject[0].param_value);



          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);
            }
          }
        },
        err => {
          return console.error(err);
        }
      );
  }
  get f() { return this.adddeviceForm.controls; }
  changeTime(e) {
  }

  add_device() {

    var deviceInfo =
    {
      "make_id": this.adddeviceForm.controls['make_id'].value,
      "param_no": this.adddeviceForm.controls['param_id'].value,
      "param_bit": this.adddeviceForm.controls['param_bit'].value,
      "alarm_name": this.adddeviceForm.controls['alarm_name'].value,
      "alarm_msg": this.adddeviceForm.controls['alarm_msg'].value,
      "param_value": this.adddeviceForm.controls['param_value'].value,
    }

    this.dashbord.addErrorLog(deviceInfo)
      .pipe(takeUntil(this.ResponseVerifiedAddDevice$))
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.toastr.success(data.message);
          this.router.navigate(['/inject-solar/error-log']);


        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(data.message);

          }

        }
      },
        err => {
          return console.log(err);
        })
  }
  // getAllEpc() {

  //   this.getEpcObj={
  //     search :"",
  //     limit:0,
  //     offset:0
  //   }
  //   this.dashbord.getAllEpcUser(this.getEpcObj)
  //     .pipe(takeUntil(this.ResponseVerifiedUpdateDevice$))
  //     .subscribe(data => {
  //       if (data.status === true || data.status === 'true') {
  //         this.router.navigate(['/inject-solar/devices']);
  //         this.toastr.success(data.message);

  //       } else if (!data.status) {
  //         if (data.message == 'Unauthorised or Login Time-out') {
  //           this.toastr.info(data.message);
  //           this.router.navigate(["/login"]);

  //         } else {
  //           this.toastr.info(data.message);

  //         }

  //       }
  //     },
  //       err => {
  //         return console.log(err);
  //       })
  // }

  update_device() {

    var deviceInfo =
    {
      "err_no": this.error_no,
      "make_id": this.adddeviceForm.controls['make_id'].value,
      "param_no": this.adddeviceForm.controls['param_id'].value,
      "param_bit": this.adddeviceForm.controls['param_bit'].value,
      "alarm_name": this.adddeviceForm.controls['alarm_name'].value,
      "alarm_msg": this.adddeviceForm.controls['alarm_msg'].value,
      "param_value": this.adddeviceForm.controls['param_value'].value
    }
    this.dashbord.updateError(deviceInfo)
      .pipe(takeUntil(this.ResponseVerifiedUpdateDevice$))
      .subscribe(data => {
        if (data.status === true || data.status === 'true') {
          this.router.navigate(['/inject-solar/error-log']);
          this.toastr.success(data.message);

        } else if (!data.status) {
          if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(["/login"]);

          } else {
            this.toastr.info(data.message);

          }

        }
      },
        err => {
          return console.log(err);
        })
  }


  onReset() {
    this.adddeviceForm.reset();
  }


  // Select DropDown of Epc user List for admin add device
  onEpcChange(value) {

  }


  // get alladmin epc user list
  getAllEpcUser() {
    this.dashbord.getAllModelMakeId()
      .pipe(takeUntil(this.ResponseVerifiedGetAllEpcUser$))
      .subscribe(
        async data => {
          if (data.status == true) {
            this.adminEpcUserList = data.resultObject;
          } else if (!data.status) {
            if (data.message == 'Unauthorised or Login Time-out') {
              this.toastr.info(data.message);
              this.router.navigate(["/login"]);

            } else {
              this.toastr.info(data.message);

            }

          }
        },
        err => {
          return console.error(err);
        }
      );
  }

  ngOnDestroy() {
    this.ResponseVerifiedGetAllEpcUser$.next();
    this.ResponseVerifiedGetAllEpcUser$.complete();

    this.ResponseVerifiedGetDeviceInfo$.next();
    this.ResponseVerifiedGetDeviceInfo$.complete();

    this.ResponseVerifiedUpdateDevice$.next();
    this.ResponseVerifiedUpdateDevice$.complete();

    this.ResponseVerifiedAddDevice$.next();
    this.ResponseVerifiedAddDevice$.complete();
  }
}
